module.exports = __webpack_public_path__ + "media/images/icon__close--rb-gray@3x-e0faa037f536cdb55c28ac04179c39b2.png";